import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/AxiosInstance';
import { performFlowdoLogout } from '../../utils/flowdoSession';

/**
 * Public route used by external modules (e.g. Snap Bill) to end the Flowdo session.
 * Clears refresh cookie via API and wipes client storage, then sends user to login.
 */
export default function ModuleLogout() {
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      await performFlowdoLogout(axiosInstance);
      if (!cancelled) {
        navigate('/login', { replace: true });
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '40vh' }}>
      <div className="spinner-border text-primary mb-3" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="text-muted mb-0">Signing you out of flowdo…</p>
    </div>
  );
}
